<button
  (click)="onDownloadSpreadsheet()"
  class="neptune-button-blue justify-start"
  [ngClass]="
    downloadSpreadSheetStatus === DownloadSpreadsheetStatusEnum.Idle
      ? ''
      : 'animate-pulse cursor-wait'
  "
  [disabled]="disabled"
>
  <div class="relative">
    <!-- Ghost span to maintain button width based on the longest possible text -->
    <span class="invisible flex items-center gap-2 whitespace-nowrap">
      <span class="!h-4 !w-4 shrink-0"></span>
      {{ longestButtonText }}
    </span>
    <div class="absolute inset-0 flex items-center gap-2">
      <img class="!h-4 !w-4" src="assets/shared-icons/neptune-download-icon.svg" />
      {{ buttonText }}
    </div>
  </div>
</button>
